(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuController', OnuController);

    OnuController.$inject = ['$scope', '$state', 'OnuService'];

    function OnuController($scope, $state, OnuService) {

    }
})();